export const OGRNIP_MASK: RegExp[] = new Array(15).fill(/[0-9]/, 0, 15);
